const NoChatSelected = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ height: "100%", minHeight: "500px" }}>
      <i className="fa fa-comments fa-3x text-muted mb-3" />
      <h5 className="text-muted">No Conversation Selected</h5>
      <p className="text-muted">Please select a chat from the left to start messaging.</p>
    </div>
  )
}

export default NoChatSelected;